import { render, staticRenderFns } from "./label-value.vue?vue&type=template&id=06e5db9c&scoped=true&"
var script = {}
import style0 from "./label-value.vue?vue&type=style&index=0&id=06e5db9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5db9c",
  null
  
)

export default component.exports